import { BaseType } from '../../base/base-type';
import { MemberContributionFrequencyEnum } from '../../enum/shared/member-contribution-frequency-enum';

export class MemberContributionFrequencyType extends BaseType {
  public declare id: MemberContributionFrequencyEnum;
  public description!: string;
}
